import React from "react"

const XSVG2 = (props)=>{
    return <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 19L19 3M19 19L3 3" stroke="black" stroke-opacity="0.8" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

}

export default XSVG2